import { useEffect } from "react"

import { Layout, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useParams } from "react-router"

import LoginHeader from "../Components/LoginHeader"
import { confirmEmail } from "./LoginPage/redux/auth.thunks"

import "./CheckEmailCode.less"

const { Text } = Typography
const CheckEmailCode = ({ confirmEmail, fetching }) => {
  const { hash } = useParams()
  const { t } = useTranslation()

  useEffect(() => {
    document.title = "Confirm Email - Chargeback"
    if (hash) confirmEmail(hash)
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  return (
    <Layout>
      <div className="login-row">
        <LoginHeader withLogout={true} />

        <Spin spinning={fetching}>
          <div className="login-content check-email-code">
            <div className="page-content">
              <Text type="secondary">{t("Email confirmation")}</Text>
            </div>
          </div>
        </Spin>
      </div>
    </Layout>
  )
}

const mapStateToProps = (state) => ({
  fetching: state?.auth?.fetching
})

const mapDispatchToProps = (dispatch) => ({
  confirmEmail: (hash, redirect) => dispatch(confirmEmail({ hash, redirect }))
})

export default connect(mapStateToProps, mapDispatchToProps)(CheckEmailCode)
